import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import TenantPage from 'components/common/TenantPage';
import { ticketingService } from 'services/api';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { useTicketColumns } from 'components/common/enhanced/common-headers';
import { canViewTechnicianCreatedTickets } from 'components/helpers/IsBottomFromTechnician';
import toast from 'features/toast';

export const TechnicianCreatedTickets = () => {
  const translationPrefix = 'pages.tickets';
  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  if (!canViewTechnicianCreatedTickets()) {
    return <Navigate to="/tenant/equipments/ticketing" replace />;
  }

  const handleDelete = (id: number) => {
    ticketingService.delete(id).then(() => {
      toast.success(t('actions.successfully.deleted'));
      datagridRefresh.current();
    });
  };

  const columns = useTicketColumns({
    handleDelete,
    excludeFields: ['warehouse_code']
  });

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.technician-created`)}
        subtitle={t(`${translationPrefix}.subtitle`)}>
        <EnhancedDataGrid
          columns={columns}
          service={ticketingService}
          getMethod={ticketingService.getTechnicianCreated}
          refresh={datagridRefresh}
          disableDelete
          initialOptions={{
            pinnedColumns: { left: [], right: [] }
          }}
        />
      </TenantPage>
    </>
  );
};

export default TechnicianCreatedTickets;
